module.exports = __webpack_public_path__ + "static/img/solutionConceptPic1.b432801.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/solutionConceptPic1.jpg
// module id = MqBF
// module chunks = 0